import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MapaMapboxComponent } from './mapa-mapbox/mapa-mapbox.component';

const routes: Routes = [{ path: '', component: MapaMapboxComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MapaRoutingModule {}
